// src\components\Payroll\PayrollSalaryBatchFld\PartialSalaryBatch.js
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button,
  GeneralMessage,
  useGeneralMessage,
} from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { formatDateLong } from "../../../utils/textUtils";
import { StatusBadge } from "../../../common/Badge"; // ADDED

import { usePartialSalaryBatch } from "./shared/usePartialSalaryBatch";
import { PartialSalaryBatchModal } from "./shared/PartialSalaryBatchModal";
import { WorkflowStatus } from "../../../utils/enums";

function PartialSalaryBatch({ user, isHideSideMenu }) {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  const {
    loading,
    dropdownsLoading,
    requestLoading,
    data,
    options,
    setIsGenerate,
    handleAdd,
    handleUpdate,
    handleFilter,
  } = usePartialSalaryBatch({ user, showGeneralMessage });

  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("add");
  const [selectedData, setSelectedData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setIsGenerate(true);
  }, []);

  const openModal = (item = null, formMode = "add") => {
    setSelectedData(item);
    setMode(formMode);
    setShowModal(true);
  };

  // ── Table config ──────────────────────────────────────────────────────────
  const headers = [
    "ID",
    "Payroll Identifier",
    "Payroll Period",
    "Effective Date",
    "Status",
    "Actions",
  ];
  const accessors = [
    "id",
    "payrollPeriodIdentifier",
    "payrollPeriodName",
    "effectiveDate",
    "statusDisplay",
    "actions",
  ];

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => {
        console.log({ item });
        openModal(item, "edit");
      },
      disabled: (item) => item.status !== WorkflowStatus.STAGING,
      visible: (item) => item.status !== WorkflowStatus.STAGING,
    },
    {
      name: "View",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600 flex items-center",
      function: (item) => openModal(item, "view"),
      visible: true,
    },
  ];

  const renderCustomCell = (row, accessor) => {
    if (accessor === "effectiveDate") return formatDateLong(row[accessor]);
    // MODIFIED: replaced inline badge JSX with StatusBadge component
    if (accessor === "statusDisplay") return <StatusBadge status={row.status} />;
    return null;
  };

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="MainteInfo shadow-xl">
          <div className="mainteHeader">
            <div className="sub-title row">
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                {"Payroll Module > "}
              </span>
              <span style={{ borderBottom: "1px solid black" }}>{"Partial Salary Batch"}</span>
            </div>
            <h3>Partial Salary Batch</h3>
          </div>

          <div className="p-4 space-y-4">
            <SearchBar handleFilter={handleFilter} />

            <Button
              icon={<AddIcon />}
              name="Add Partial Salary Batch"
              className="bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"
              onClick={() => openModal(null, "add")}
            />

            <CreateTable
              tableName="PartialSalaryBatchTable"
              headers={headers}
              accessors={accessors}
              data={data}
              actions={actions}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={10}
              totalItems={data?.length}
              customCellRenderer={renderCustomCell}
            />
          </div>
        </div>
      </div>

      <PartialSalaryBatchModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        showGeneralMessage={showGeneralMessage}
        mode={mode}
        selectedData={selectedData}
        options={options}
        dropdownsLoading={dropdownsLoading}
        onAdd={handleAdd}
        onUpdate={handleUpdate}
      />

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={loading || dropdownsLoading || requestLoading} />
    </div>
  );
}

export default PartialSalaryBatch;